<template>
    <Paper class="p-4">
        <div class="d-flex align-items-center mb-3">
            <BaseIcon
                v-if="testsCompleted"
                class="mr-2"
                name="check-circle"
                style="color:var(--success)"
                size="sm"
            />
            <h6 class="caption mute mb-0">
                {{
                    testsCompleted
                        ? $t('tests.cute.shortcuts.seeYourScore')
                        : $t('tests.cute.shortcuts.header')
                }}
            </h6>
        </div>
        <div
            v-for="test in tests"
            :key="test.key"
            class="d-flex align-items-center py-1 pointer clickable"
            @click="openTest"
        >
            <BaseIcon class="mr-2" name="play" size="xs" />
            <h6 class="caption mb-0">
                {{ $t(`tests.cute.tests.${test.id}.label`) }}
            </h6>
        </div>
    </Paper>
</template>

<script>
import i18n from '~/i18n';

export default {
    name: 'TestShortcuts',
    props: {
        tests: {
            type: Array,
            default: () => [],
        },
        testsCompleted: Boolean,
    },
    computed: {},
    methods: {
        openTest() {
            this.$emit('open-test');
        },
    },
};
</script>

<style lang="scss" scoped></style>
